import styled from "styled-components/macro";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f3f1e4;
  min-height: 100vh;

  .sudowrite-explainer {
    border: 2px solid rgba(56, 56, 56, 0.1);
    border-radius: 32px;
    padding: 2em;
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 1195px;
    .sudowrite-banner {
      width: 339.534px;
      height: 263.879px;
      flex-shrink: 0;
      // background: lightgray 50% / cover no-repeat;
    }
    .explainer-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 1em;
      text-align: left;
      .intro {
        font-size: 1.2em;
      }
      p {
        margin: 0;
        font-family: "GT Super Text";
        line-height: 1.5em;
        margin-bottom: 1em;
      }
      button {
        width: 200px;
        height: 50px;
        background: #4908d1;
        border-radius: 12px;
        color: white;
        font-size: 1.2em;
        border: 0;
      }
    }
  }
  .footer-container {
    margin-top: 2em;
  }
`;
